import { AppProps } from "next/app";
import "../css/tailwind.css";
import "draft-js/dist/Draft.css";
import Head from "next/head";

export default function App({
  Component,
  pageProps,
  err,
}: AppProps & { err: any }) {
  return (
    <>
      <Head>
        <title>Ghostform – Einfach Online Verträge Abschließen</title>
      </Head>
      <Component {...pageProps} err={err} />
    </>
  );
}
